/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * B2B Backend API
 * API documentation for B2B Platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  Contract,
  MatchRequestsContractsExportRetrieveParams,
  MatchRequestsContractsListParams
} from '.././model'
import { customInstance } from '../../../../api/client';



/**
 * List all contracts where your company participates either as the requester (companyA) or the matched company (companyB). Optional search on counterpart company name; filter by status and type. Use status=all-status (or similar) and type=all-types for no filter. Paginated.
 * @summary List my company's contracts
 */
export const matchRequestsContractsList = (
    params?: MatchRequestsContractsListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<Contract[]>(
      {url: `/api/v1/matchRequests/contracts/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getMatchRequestsContractsListQueryKey = (params?: MatchRequestsContractsListParams,) => {
    return [`/api/v1/matchRequests/contracts/`, ...(params ? [params]: [])] as const;
    }

    
export const getMatchRequestsContractsListQueryOptions = <TData = Awaited<ReturnType<typeof matchRequestsContractsList>>, TError = unknown>(params?: MatchRequestsContractsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof matchRequestsContractsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMatchRequestsContractsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof matchRequestsContractsList>>> = ({ signal }) => matchRequestsContractsList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof matchRequestsContractsList>>, TError, TData> & { queryKey: QueryKey }
}

export type MatchRequestsContractsListQueryResult = NonNullable<Awaited<ReturnType<typeof matchRequestsContractsList>>>
export type MatchRequestsContractsListQueryError = unknown

/**
 * @summary List my company's contracts
 */
export const useMatchRequestsContractsList = <TData = Awaited<ReturnType<typeof matchRequestsContractsList>>, TError = unknown>(
 params?: MatchRequestsContractsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof matchRequestsContractsList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getMatchRequestsContractsListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Download all contracts where your company participates (as requester or matched) as a flat Excel-friendly CSV file.

Supports the same `search`, `status`, and `type` filters as the JSON list endpoint.
 * @summary Download my company's contracts as Excel (CSV)
 */
export const matchRequestsContractsExportRetrieve = (
    params?: MatchRequestsContractsExportRetrieveParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/matchRequests/contracts/export/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getMatchRequestsContractsExportRetrieveQueryKey = (params?: MatchRequestsContractsExportRetrieveParams,) => {
    return [`/api/v1/matchRequests/contracts/export/`, ...(params ? [params]: [])] as const;
    }

    
export const getMatchRequestsContractsExportRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof matchRequestsContractsExportRetrieve>>, TError = unknown>(params?: MatchRequestsContractsExportRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof matchRequestsContractsExportRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMatchRequestsContractsExportRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof matchRequestsContractsExportRetrieve>>> = ({ signal }) => matchRequestsContractsExportRetrieve(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 600000, refetchOnMount: false,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof matchRequestsContractsExportRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type MatchRequestsContractsExportRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof matchRequestsContractsExportRetrieve>>>
export type MatchRequestsContractsExportRetrieveQueryError = unknown

/**
 * @summary Download my company's contracts as Excel (CSV)
 */
export const useMatchRequestsContractsExportRetrieve = <TData = Awaited<ReturnType<typeof matchRequestsContractsExportRetrieve>>, TError = unknown>(
 params?: MatchRequestsContractsExportRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof matchRequestsContractsExportRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getMatchRequestsContractsExportRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



